import React from 'react';
import { Suspense, lazy } from 'react';
import { connect } from 'react-redux';

// PageElements
import ReduxManager from 'components/v2/PageElements/ReduxManager';
import Route, { Switch } from 'components/v2/PageElements/Routes';

// Redux State Mappers
import { mapPermissionsToProps } from 'mappers/v1/permissions';

// Config
import paths from 'config/paths/customFields';

// Components
const Index = lazy(() => import('./index'));
const ResourceLayout = lazy(() => import('./Detail'));

/*
 * Important thing to note about Resourceful layouts.
 *
 * If you want sublayouts such as those defined in "Detail" to successfully render
 * you cannot use exact paths, you are partial matching on the parent to ensure
 * the top level layout always gets loaded so that any child pages also get loaded.
 */

export const Routes = ({ paths, permissions }) => {
  // Redux Manager can handle loading any data necessary for the feature to function
  // see the component definition for available data/actions
  return (
    <ReduxManager data={['customFieldsDropdown', 'customFieldsSchema']}>
      <Suspense fallback={<></>}>
        <Switch>
          <Route permission={permissions.customFields.list} exact path={paths.root}>
            <Index paths={paths} />
          </Route>
          <Route
            exact
            permission={permissions.customFields.list}
            path={paths.resource.detail(':id')}
          >
            <ResourceLayout paths={paths} />
          </Route>
        </Switch>
      </Suspense>
    </ReduxManager>
  );
};

export default connect(mapPermissionsToProps, null)((props) => <Routes paths={paths} {...props} />);
